/* eslint-disable no-extra-boolean-cast,react/jsx-boolean-value */
import React, { PropTypes } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { dateConfig } from '../../../../configureApp';
import Icon from '../../../../components/Icon';
import { getNZDateTime } from '../../../../utils/dateUtil';
import { appConfig } from '../../../../configureApp';

const Span = styled.span`
  display: inline-flex;
`;

class MyDatePicker extends React.Component {

  constructor(props) {
    super(props);
    this.handleIconClick = this.handleIconClick.bind(this);
    this.toISOString = this.toISOString.bind(this);
    this.state = {
      readOnly: false,
    };
  }

  dayPicker = {};

  handleIconClick() {
    if (this.props.disabled) {
      return;
    }
    if (this.dayPicker) {
      // this.dayPicker.showDayPicker();
      // this.dayPicker.focus();
      this.dayPicker.setOpen(true);
    }
  }

  formatDate(date) {
    return (!!date && date !== 'N/A') ? moment(date).format(dateConfig.dateFormat) : '';
  }

  toISOString(date) {
    if (!!date) {
      this.props.onDayChange(date.toISOString());
    }
  }

  render() {
    const { disabled, position } = this.props;

    if (disabled) {
      return (
        <input
          disabled={true}
          value={this.formatDate(this.props.value)}
          className='disabled'
          style={{ ...inputStyle, ...this.props.style, backgroundColor: 'lightgray' }}
        />
      );
    }
    return (
      <DatePicker
        disabled={this.props.disabled}
        selected={!this.props.value ? null : moment(this.props.value)}
        ref={(datePicker) => {
          this.dayPicker = datePicker;
        }}
        maxDate={getNZDateTime()}
        customInput={
          <Span
            style={{
              width: '100%',
              backgroundColor: '#fff',
              // borderRadius: '4px',
              ...this.props.style,
            }}
          >
            <input
              disabled={this.props.disabled}
              value={this.formatDate(this.props.value)}
              style={inputStyle}
              onFocus={() => this.setState({ readOnly: true })}
              onBlur={() => this.setState({ readOnly: false })}
              readOnly={this.state.readOnly}
            />
            <Icon
              name="fa-calendar"
              onClick={this.handleIconClick}
              style={{
                cursor: 'pointer',
                padding: 8,
                position: 'absolute',
                right: 0,
              }}
            />
          </Span>
        }
        onChange={this.toISOString}
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        popperPlacement={!!position ? position : 'bottom-start'}
        popperModifiers={{
          preventOverflow: {
            enabled: true,
            escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
            // boundariesElement: 'viewport'
          },
          flip: {
            enabled: false,
          },
        }}
      />
    );
  }
}

MyDatePicker.propTypes = {
  style: PropTypes.any,
  disabled: PropTypes.any,
  value: PropTypes.any,
  onDayChange: PropTypes.any,
  position: PropTypes.any,
};

export default MyDatePicker;

const inputStyle = {
  borderWidth: 1,
  borderColor: appConfig.reactAppEnv === 'scti' ? '#D1D1D1' : '#ccc',
  borderStyle: 'solid',
  fontSize: appConfig.reactAppEnv === 'scti' ? '16px' : '0.86em',
  padding: 5,
  paddingRight: 30,
  fontFamily: 'inherit',
  width: '100%',
  borderRadius: appConfig.reactAppEnv === 'scti' ? '8px' : '0px',
  backgroundColor: '#fff',
};




// WEBPACK FOOTER //
// ./app/containers/FastCover/components/DatePicker/index.js